<!--回放列表-->
<template>
  <section class="list-sec">
    <load-more ref="loadMore" :loadmore="fetchData" :list="list">
      <template v-slot:default>
        <div class="list-item-con">
          <replay-item v-for="item in list" :key="item.id" :item="item" @itemClick="goToReplayDetails"></replay-item>
        </div>
      </template>
      <template v-slot:noDataTip>
        <p>当前暂无回放</p>
      </template>
    </load-more>
  </section>
</template>

<script>
  import ReplayItem from './replayItem'
  import { getReplayList } from 'api/live'
  import LoadMore from 'components/LoadMore'
  import { getPlatform } from 'lib/tools/getPlatform'
  import Bridge from 'lib/lib/Bridge'
  import { getToken } from '@/utils/utils'

  export default {
    name: "ReplayList",
    components: {
      ReplayItem,
      LoadMore
    },
    data() {
      return {
        list:[],
        h5Appear: false
      }
    },
    mounted() {
      /*App返回刷新页面*/
      let { isYixinliApp } = getPlatform()
      if (isYixinliApp) {
        this.handleAppActive()
      }
      this.$stat.send({
        name: `直播-页面访问`,
        properties: {
          页面: '回放列表页',
        }
      })
    },
    methods: {
      fetchData($event) {
        return new Promise((resolve) => {
          getReplayList({
            pageNo: $event.pageNo,
            pageSize: $event.pageSize
          }).then(({code, data}) => {
            if (+code === 0) {
              if (this.h5Appear) { // 从详情页返回列表页重新请求数据，为了防止闪动，拿到数据后直接替换
                this.list = data.list
                this.h5Appear = false
              } else { // 上滑加载更多直接拼接数据
                this.list = this.list.concat(data.list)
              }
              resolve(data)
            }
          })
        })
      },
      handleAppActive() {
        const _this = this
        let methodsList = [
          {
            method: 'appBecomeActiveStatus',
            callback(obj) {
              if (obj.data.status === 'h5Appear') {
                if (_this.$refs.loadMore.loading) return false
                _this.h5Appear = true // 标记是从上一个页面返回来的
                _this.$refs.loadMore.finish = false
                _this.$refs.loadMore.pageNo = 1
                _this.$refs.loadMore.init()
              }
            }
          }
        ]

        new Bridge({
          methods: methodsList
        })
      },
      goToReplayDetails($event) {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播',
            行为: '点击',
            对象: '回放点击',
            页面: '回放列表页',
            页面title: $event.title
          }
        })
        let token = getToken()
        let isYixinliApp = getPlatform().isYixinliApp
        if (isYixinliApp) {
          window.location.href = `yixinli://open_live_replay?replay_id=${$event.id}`
        } else {
          this.$router.push({
            path: '/previewDetails',
            query: {
              id: $event.id,
              type: 'replay',
              token
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.list-sec {
  min-height: 100vh;
  width: 100%;

  .list-item-con {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 30px;
  }
}
</style>